const BREAKING_NEWS_DATA = {
  /* If true, we display the articles from manual-articles JSON file */
  useManualData: false,
  articles: [
    {
      key: 1739780,
      id: 1739780,
      title: 'Fed Stands Pat and Weekly Mortgage Rates Inch Higher',
      authorImageUrl:
        'https://www.nerdwallet.com/assets/blog/wp-content/uploads/2024/10/Holden-Lewis-Vegas-e1725999060243-160x160.png',
      authorLink: 'https://www.nerdwallet.com/author/holden-lewis',
      author: 'Holden Lewis',
      articleLink:
        'https://www.nerdwallet.com/article/mortgages/weekly-mortgage-rates-5-7-25',
      date: 'May 7, 2025',
      displayDate: 'May 7, 2025',
      readTime: 2,
      alternativeVersion: false,
    },
    {
      key: 1222802,
      id: 1222802,
      title: 'What Is Stagflation? Are We Experiencing It Now?',
      authorImageUrl:
        'https://www.nerdwallet.com/assets/blog/wp-content/uploads/2022/03/Taryn-bio-photo-160x160.jpeg',
      authorLink: 'https://www.nerdwallet.com/author/taryn-phaneuf',
      author: 'Taryn Phaneuf',
      articleLink:
        'https://www.nerdwallet.com/article/finance/what-is-stagflation',
      date: 'May 8, 2025',
      displayDate: 'May 8, 2025',
      readTime: 2,
      alternativeVersion: false,
    },
    {
      key: 1725238,
      id: 1725238,
      title: 'Survey: Women’s Finances More Precarious Than Men’s',
      authorImageUrl:
        'https://www.nerdwallet.com/tachyon/2021/09/IMG_8802.jpg?resize=160%2C160',
      authorLink: 'https://www.nerdwallet.com/author/erin-el-issa',
      author: 'Erin El Issa',
      articleLink:
        'https://www.nerdwallet.com/article/investing/survey-womens-finances-more-precarious-than-mens',
      date: 'May 6, 2025',
      displayDate: 'May 6, 2025',
      readTime: 3,
      alternativeVersion: false,
    },
    {
      key: 1706357,
      id: 1706357,
      title: 'Today’s Car Market: Are Car Prices Going Up or Down?',
      authorImageUrl:
        'https://www.nerdwallet.com/assets/blog/wp-content/uploads/2021/07/Shannon-Bradley-2021-Copy-Shannon-Bradley-e1626974162152-160x160.jpg',
      authorLink: 'https://www.nerdwallet.com/author/shannon-bradley',
      author: 'Shannon Bradley',
      articleLink: 'https://www.nerdwallet.com/article/cars/car-market-prices',
      date: 'May 9, 2025',
      displayDate: 'May 9, 2025',
      readTime: 6,
      alternativeVersion: false,
    },
  ],
};

export default BREAKING_NEWS_DATA;
